import { createSelector } from 'reselect';
import { languageForLocale } from '../../utils/locale';

const getAlternateLocales = (state) => state.landingPage.alternateLocales || [];
const getHostname = (state) => state.request.host;
const getIsoCode = (state) => state.request.country.isoCode;
const getCurrentQuery = (state) => state.request.currentQuery || {};

export const alternateLocaleUrlsSelector = createSelector(
  [getHostname, getIsoCode, getAlternateLocales],
  (hostname, isoCode, alternateLocales) =>
    alternateLocales.map(({ locale, path }) => ({
      href: `${hostname}/${locale.toLowerCase()}${path}`,
      hrefLang: languageForLocale(locale, isoCode),
    })),
);

export const hasQueryParamsSelector = createSelector([getCurrentQuery], (currentQuery) => {
  // On landing pages, certain params are returned in request.currentQuery, we
  // want to ignore these. any additional params in the object will come from a
  // query string.
  const BLACKLIST_PARAMS = ['locale', 'cuisine', 'city', 'path', 'brand'];
  const queryParams = Object.keys(currentQuery).filter(
    (param) => !BLACKLIST_PARAMS.includes(param),
  );

  return Boolean(queryParams.length);
});
